import { useQuery } from '@tanstack/react-query';
import { fetcher } from '@/utils/fetcher';
import { RETAIL_API_URL } from 'src/utils/envConfig';
import { StoredSlide } from '@/types/SlideType';

interface IUseLibrarySlidesProps {
  customerId: string;
}

export const useLibrarySlides = ({ customerId }: IUseLibrarySlidesProps) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [],
    queryFn: () =>
      fetcher<readonly StoredSlide[]>(
        `${RETAIL_API_URL}/slides/read/library?customer=${customerId}`,
      ),
    enabled: Boolean(customerId),
  });

  return {
    data,
    isLoading,
    refetch,
  };
};
